module.exports = "../imgs/3014267ac72bc67cd30124adc52df7b4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/imgs/background.png
// module id = 793
// module chunks = 1